import { combineReducers } from 'redux';

import { tenantReducer, ITenantState } from '../modules/tenant/reducers';
import { integrationsReducer, IIntegrationsState } from '../modules/integrations/reducers';
import { counterpartyReducer, ICounterpartyState } from '../modules/counterparty/reducers';


export interface IBusinessState {
	tenant: ITenantState;
	integrations: IIntegrationsState;
	counterparty: ICounterpartyState;
}

const businessRootReducer = combineReducers<IBusinessState>({
	tenant: tenantReducer,
	integrations: integrationsReducer,
	counterparty: counterpartyReducer,
});

export {
	businessRootReducer,
};
